import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { makeStyles, TeachingPopover, TeachingPopoverBody, TeachingPopoverHeader, TeachingPopoverSurface } from "@fluentui/react-components";
const useStyles = makeStyles({
    extensionTeachingPopover: {
        maxWidth: "320px",
    },
});
/**
 * A component that displays a teaching moment popover.
 * @param props Props for the teaching moment popover.
 * @returns The teaching moment popover.
 */
export const TeachingMoment = ({ shouldDisplay, positioningRef, onOpenChange, title, description }) => {
    const classes = useStyles();
    return (_jsx(TeachingPopover, { appearance: "brand", open: shouldDisplay, positioning: { positioningRef }, onOpenChange: onOpenChange, children: _jsxs(TeachingPopoverSurface, { className: classes.extensionTeachingPopover, children: [_jsx(TeachingPopoverHeader, { children: title }), _jsx(TeachingPopoverBody, { children: description })] }) }));
};
//# sourceMappingURL=teachingMoment.js.map